import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../../ui/Button";
import { normalizePeers, RELATIVE_ENABLED } from "../../lib/relative";
import { AddRelativePeersContext } from "./relativePeerContext";

export default function RelativeLink({rows, source}: {rows: Record<string, unknown>[]; source:string}) {
  const navigate = useNavigate();
  const location = useLocation();
  const addPeers = useContext(AddRelativePeersContext);
  if (!RELATIVE_ENABLED || !rows.length) return null;
  const normalized = normalizePeers(rows);
  return <Button variant="primary" disabled={!normalized.peers.length}
    title={!normalized.peers.length ? "상대가치평가는 국내 상장기업을 지원합니다." : undefined}
    onClick={() => addPeers ? addPeers(normalized.peers, source) : navigate("/peer/relative", {state:{relativeSeed:{id:crypto.randomUUID(), ...normalized,
      source, sourceUrl:location.pathname + location.search}}})}>
    {addPeers ? "이 기업들을 평가에 추가" : "이 기업들로 상대가치평가"} <ArrowRight size={14} />
  </Button>;
}
